<template>
  <div>
    <yunying  :caozuo_flag_props="3" > </yunying> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import yunying from '../../tongyong/yunying.vue';
 
export default {

  components: {
    yunying: yunying 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
